export default __webpack_public_path__ + "static/media/sdlc.18778b75.svg";